import { GlobalAxios } from "../axios/axios-config";
import {
  IMemberAvailabilityPauseReason,
  INewMemberAvailabilityPauseReason,
} from "../models/member-availability-pause-reason";

const EVENT_TYPE_ROUTE =
  process.env.REACT_APP_TICKETS +
  "/api/v1/TicketChannelMemberAvailabilityPauseReason/";

export const createMemberAvailabilityPauseReason = (
  item: INewMemberAvailabilityPauseReason
) => {
  return GlobalAxios.post(EVENT_TYPE_ROUTE, item);
};

export const getMemberAvailabilityPauseReasonById = (id: string) => {
  return GlobalAxios.get<IMemberAvailabilityPauseReason>(EVENT_TYPE_ROUTE + id);
};

export const updateMemberAvailabilityPauseReasonById = ({
  item,
  id,
}: {
  item: INewMemberAvailabilityPauseReason;
  id: string;
}) => {
  return GlobalAxios.put(EVENT_TYPE_ROUTE + id, item);
};
